import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import PageHeader from "../../components/PageHeader";
import { StatCard } from "../../components/StatCard";
import { LayoutDashboard, Users, UserX, FolderKanban, CalendarClock } from "lucide-react";
import { AgendaPanel } from "./Agenda";
import ScadenzeImminenti from "../../components/ScadenzeImminenti";

export default function StudioDashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [studio, setStudio] = useState(null);
  const [scadenzeCount, setScadenzeCount] = useState(null);
  const [praticheAperte, setPraticheAperte] = useState(null);

  useEffect(() => {
    api.get("/studio/stats").then(({ data }) => setStats(data)).catch(() => {});
    api.get("/studio/me").then(({ data }) => setStudio(data)).catch(() => {});
    api.get("/studio/pratiche/count-aperte").then(({ data }) => setPraticheAperte(data.count ?? 0)).catch(() => {});
  }, []);

  return (
    <div data-testid="studio-dashboard">
      <PageHeader
        title={studio ? studio.studio_name : "Dashboard Studio"}
        subtitle={`Benvenuto/a, ${user.name}. Panoramica operativa del tuo studio.`}
        icon={LayoutDashboard}
      />
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard label="Clienti" value={stats?.clienti ?? "—"} icon={Users} accent="amber" testId="stat-clienti"
          onClick={() => navigate("/app/anagrafiche")} />
        <StatCard label="Controparti" value={stats?.controparti ?? "—"} icon={UserX} accent="slate" testId="stat-controparti"
          onClick={() => navigate("/app/anagrafiche")} />
        <StatCard label="Pratiche Aperte" value={praticheAperte ?? stats?.pratiche_aperte ?? "—"} icon={FolderKanban} accent="slate" testId="stat-pratiche"
          onClick={() => navigate("/app/pratiche?stato=aperta")} />
        <StatCard label="Scadenze Settimana" value={scadenzeCount ?? stats?.scadenze_settimana ?? "—"} icon={CalendarClock} accent="red" testId="stat-scadenze"
          onClick={() => navigate("/app/agenda")} />
      </div>

      <ScadenzeImminenti onCount={setScadenzeCount} />

      <div className="pgp-card p-6 mt-6 pgp-fade-up" data-testid="dashboard-agenda">
        <AgendaPanel embedded />
      </div>
    </div>
  );
}
